import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import { CoinImage, DiamondImage } from '@/app/shared/components';
import './RewardDayItem.css';

interface MenuOptionProps {
	numDay: number;
	isRewardCompleted: boolean;
	claimable: boolean;
	reward: number;
	rewardType: number;
	onClickDay: (selectedDay: number) => void;
}

export const RewardDayItem: React.FC<MenuOptionProps> = ({
	numDay,
	isRewardCompleted,
	claimable,
	reward,
	rewardType,
	onClickDay,
}: MenuOptionProps) => {
	// debugger;
	/*********************
	// #region Constants
	**********************/
	const bgColor = isRewardCompleted
		? ' bg-day-reward-gradient'
		: 'bg-customer-900/70';
	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div
				className={`flex flex-col rounded-2xl items-center shadow-lg py-2 ${bgColor}  ${
					claimable
						? 'border-gradient-tr-claimable-daily-reward-gray-900  gradient-border-2 shadow-blue-30/50 animate-reward'
						: 'border-2 shadow-blue-30/30 '
				}`}
				onClick={() => {
					if (claimable && !isRewardCompleted) {
						onClickDay(numDay);
					}
				}}
			>
				<p className="w-full text-sm font-semibold text-center">
					Day {numDay}
				</p>
				{rewardType === 1 ? (
					<CoinImage classes="w-[42px]" />
				) : (
					<DiamondImage classes="w-[36px] py-[3px]" />
				)}
				<p className="font-bold text-md w-full text-center">
					{numify(reward)}
				</p>
			</div>
		</>
	);
};
